<template>
  <span>
    {{ time }}
  </span>
</template>

<script>
import { timeformatter } from '@/components/helper/formatter'
import moment from 'moment'

export default {
  name: 'Time',
  props: {
    value: {
      type: String,
      required: true,
    },
    inputFormat: {
      type: String,
      required: true,
    },
    outputFormat: {
      type: String,
      default: 'HH:mm',
    },
    suffix: {
      type: String,
      default: 'Uhr',
    },
  },
  computed: {
    time() {
      let value = this.value
      if (this.inputFormat === 'X') {
        value = parseInt(this.value / 1000)
      }
      const date = moment(value, this.inputFormat).toDate()
      return `${timeformatter.format(date)} ${this.suffix}`
    },
  },
}
</script>
